<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Commission Log</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Commission Log</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="overlay" v-if="is_loading">
        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'CommissionLogList'}">
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body table-responsive p-0">
              <table class="table table-striped">
                <tbody>

                  <tr>
                    <td><b>ID</b></td>
                    <td>{{ value.id }}</td>
                  </tr>

                  <tr>
                    <td><b>Commission Config-Id</b></td>
                    <td>{{ value.commission_config_id }}</td>
                  </tr>

                  <tr>
                    <td><b>Account ID</b></td>
                    <td>{{ value.account_id }}</td>
                  </tr>

                  <tr>
                    <td><b>Product Count</b></td>
                    <td>{{ value.product_count }}</td>
                  </tr>

                  <tr>
                    <td><b>Total Amount</b></td>
                    <td>{{ value.total_amount }}</td>
                  </tr>

                  <tr>
                    <td><b>Commission Amount</b></td>
                    <td>{{ value.commission_amount }}</td>
                  </tr>

                  <tr>
                    <td><b>Disbursement Status</b></td>
                    <td>{{ value.disbursement_status }}</td>
                  </tr>

                  <tr>
                    <td><b>App ID</b></td>
                    <td>{{ value.app_id }}</td>
                  </tr>

                </tbody>
              </table>

            </div>
          </div>
        </div>
      </div>

    </section>
  </div>
</template>
<script>
import { CBSCommissionApi } from '@/services/api';
export default {
  name: 'CommissionLogShow',
  data: () => ({
    value: {},
    pre: {},
    is_loading: false
  }),
  mounted: function () {
    this.initialize()
  },
  methods: {
    getDetail: function (id) {
      CBSCommissionApi.showCommissionLog(id)
        .then((item) => {
          this.value = item
        })
        .catch((error) => {
          this.$toaster.error(error.response.data.message)
        })
        .finally(() => {
          this.is_loading = false
        })
    },
    async initialize () {
      this.is_loading = true
      this.params = this.$route.params
      await this.getDetail(this.params.id)
      this.is_loading = false
    }
  }
}
</script>
